interface BellProps {
    color?: string;
    width?: number;
    height?: number;
}

const Bell = ({
    color = 'black',
    width = 18,
    height = 18
}: BellProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 18 18"
        fill="none"
    >
        <path
            d="M10.2975 15.75C10.1656 15.9773 9.97638 16.166 9.74867 16.2971C9.52096 16.4283 9.26278 16.4973 9 16.4973C8.73722 16.4973 8.47904 16.4283 8.25133 16.2971C8.02362 16.166 7.83436 15.9773 7.7025 15.75M13.5 6.3C13.5 5.02725 13.026 3.80625 12.1823 2.90625C11.3385 2.00625 10.1925 1.5 9 1.5C7.8075 1.5 6.66225 2.0055 5.81775 2.90625C4.974 3.80625 4.5 5.02725 4.5 6.3C4.5 11.9002 2.25 13.5 2.25 13.5H15.75C15.75 13.5 13.5 11.9002 13.5 6.3Z"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Bell;

